// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2KqkH","error":"Textarea_error__NFVL7","readonly":"Textarea_readonly__251Ej","disabled":"Textarea_disabled__uOC1v"};